define(function (require, modules, exports) {
    var XMLtoJSON = require('data-transformers/xml-to-json');
    var JsonTransformer = require('data-transformers/json');

    var DEFAULT = 'application/json';
    var mimeTypeMap = {
        'text/xml': XMLtoJSON,
        'application/json': JsonTransformer
    };

    return function (data, request, rawResponse) {
        if (!request.success) {
            return null;
        }
        var ClassObj = this.vo;
        var json = (mimeTypeMap[this.mimetype] || mimeTypeMap[DEFAULT])(data, request);

        if (ClassObj) {
            return new ClassObj(json, request.params);
        } else {
            return json;
        }
    };
});
